'use client';
import { StateCreator } from 'zustand/index';
import { CalendarStore } from '@/hooks/use-calendar-store';
import { CalendarFilters } from '@/types/calendar-filters';

type ArrayFilterKeys = Exclude<keyof CalendarFilters, 'showTimeOffs'>;

export type FilterStore = {
  filters: CalendarFilters;
  activeCustomFilterId: string | null;
  toggleFilter: (key: ArrayFilterKeys, value: string) => void;
  toggleTimeOffs: () => void;
  resetFilters: () => void;
  applyCustomFilter: (customFilters: CalendarFilters, customFilterId: string) => void;
};

export const initialFilters: CalendarFilters = {
  categories: [],
  trades: [],
  colors: [],
  groups: [],
  eventColors: [],
  showTimeOffs: false,
};

export const createFilterSlice: StateCreator<Partial<CalendarStore> & FilterStore> = (set) => ({
  filters: initialFilters,
  activeCustomFilterId: null,
  resetFilters: () => {
    set(() => ({
      filters: initialFilters,
      activeCustomFilterId: null,
    }));
  },
  toggleFilter: (key: ArrayFilterKeys, value) => {
    set((state) => {
      const currentFilterArray = state.filters[key] ?? [];
      const isFilterActive = currentFilterArray.includes(value);
      const newFilters = {
        ...initialFilters,
        ...state.filters,
        [key]: isFilterActive
          ? currentFilterArray.filter((v) => v !== value)
          : [...currentFilterArray, value],
      };

      return {
        ...state,
        filters: newFilters,
        activeCustomFilterId: null, // Clear active custom filter when manually toggling
      };
    });
  },
  toggleTimeOffs: () => {
    set((state) => ({
      ...state,
      filters: {
        ...state.filters,
        showTimeOffs: !state.filters.showTimeOffs,
      },
      activeCustomFilterId: null,
    }));
  },
  applyCustomFilter: (customFilters, customFilterId) => {
    set(() => ({
      filters: { ...customFilters },
      activeCustomFilterId: customFilterId,
    }));
  },
});
